import styled from 'styled-components';

export const CampaignTitleInner = styled.div`
    padding: calc(100vw*(15/375)) calc(100vw*(17/375)) calc(100vw*(25/375)) calc(100vw*(16/375));
`
export const Listbox = styled.div`
    width: calc(100vw*(341/375));
    border-radius: calc(100vw*(5/375));
    border: solid calc(100vw*(1/375)) #d8d8d8;
    background-color: #ffffff;
    overflow: hidden;
`
export const ListboxTit = styled.p`
    width:100%;
    height: calc(100vw*(45/375));
    background-color: #707070;
    font-size: calc(100vw*(12/375));
    font-weight: 500;
    line-height: calc(100vw*(45/375));
    text-align: center;
    color: #ffffff;
`
export const VerificationInner = styled.div`
    padding: calc(100vw*(27.5/375)) calc(100vw*(15/375)) calc(100vw*(10/375)) calc(100vw*(16/375));
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vw*(190/375));
`

export const TodoInputBoxArea = styled.div`
    & > div:first-child > div  {
        border-top: calc(100vw*(1/375)) solid #d9d9d9;
    }
`
export const Addbtn = styled.a`
    width: calc(100vw*(22/375));
    height: calc(100vw*(22/375));
    margin-top: calc(100vw*(11.5/375));
    margin-left : calc(100vw*(19/375));
`
export const Notitext = styled.p`
    font-size: calc(100vw*(10/375));
    color: #7f7f7f;
    line-height: 1.5;
`

export const Pjtodoinner = styled.div`
    // padding: calc(100vw*(79.5/375)) 0 calc(100vw*(116/375));
    padding-top : calc(100vw*(79.5/375));
`
export const Maintit = styled.h1`
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
    padding: 0 calc(100vw*(17/375));
    margin-bottom: calc(100vw*(8/375));
`
export const Subtit = styled.p`
    font-size: calc(100vw*(11/375));
    line-height: 1.36;
    letter-spacing: 0.22px;
    color: #7f7f7f;
    padding: 0 calc(100vw*(17/375));
    margin-bottom: calc(100vw*(20/375));
`